interface ISocialButton {
  href: string;
  icon: React.ReactNode;
}

const SocialButton = ({ href, icon }: ISocialButton) => {
  // rendering custom social media button component here
  return (
    <a
      href={href}
      className="flex size-[40px] items-center justify-center rounded-full bg-legal-brown text-legal-dark-gray duration-300 hover:-translate-y-1 hover:opacity-70"
      target="_blank"
      rel="noreferrer"
    >
      {icon}
    </a>
  );
};

export default SocialButton;
